import axios from "axios";

export default {
    namespaced: true,
    state: {
        employees:[],
        employee_info:{}
    },
    getters:{
        employees(state){
            return state.parts
        },
        employee_info(state){
            return state.employee_info
        }
    },  
    mutations:{
        SET_EMPLOYEES_LIST (state, payload) {
            state.employees = payload
        },
        SET_EMPLOYEE_INFO (state, payload) {
            console.log(payload)
            state.employee_info = payload
        }
    },
    actions:{
       async getEmployeeList(context,param){
        const response = await axios.get('/api/get_employees',{
            headers:{
              'Authorization':`Bearer ${param.token}`,
              "Access-Control-Allow-Headers": "*",
               "Access-Control-Allow-Method" : "*",
               "Access-Control-Allow-Origin": "*",
               "Access-Control-Allow-Credentials": "*",
            }
          });

            if(response.status == 200){
                context.commit('SET_EMPLOYEES_LIST',response.data)
            }
       }
    }
}